import { loggedOnInfoLabel } from './Reducers/LoggedOnInfoLabel.reducer';

export const pnLoggedOnInfoLabel = {
    loggedOnInfoLabel
};